<template>
  <el-select
    v-model="value"
    @change="change"
    clearable
    filterable
    :multiple="multiple"
    size="medium"
    placeholder="需求方"
  >
    <el-option
      v-for="item in dspNameOptions"
      :key="item.dspId"
      :label="item.dspName"
      :value="item.dspId"
    />
  </el-select>
</template>

<script>
import { getDspName } from '@/api/select'
import { hot } from "@/api/hot"

export default {
  props: {
    modelValue: [String, Number, Array],
    dspType: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      dspNameOptions: [],
      value: this.modelValue !== undefined ? this.modelValue : (this.multiple ? [] : undefined)
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (this.value === newVal) return
        this.value = newVal
      },
      immediate: true
    }
  },
  created() {
    this.getDspName()
  },
  methods: {
    getDspName() {
      if (this.dspType !== 100) {
        getDspName({ dspType: this.dspType }).then(res => {
          if (res.code === 200) {
            this.dspNameOptions = res.data
          }
        })
      } else {
        getDspName().then(res => {
          if (res.code === 200) {
            this.dspNameOptions = res.data
          }
        })
      }
    },
    change(item) {
      if (!this.multiple && item) {
        let data = {
          maker: "dspOnThe",
          onTheOrderId: item
        }
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    }
  }
}
</script>
